// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthorizationDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';
const ROOT_URL = 'authorization/';

export default {
  /**
   * Load all permissions
   * @returns {promise}
   */
  loadAllPermissions(): any {
    return fetch(`${ROOT_URL}permission/`).get();
  },

  /**
   * Load permissions by key
   * @param {String} key
   * @returns {promise}
   */
  loadPermissionByKey(key: string): any {
    return fetch(`${ROOT_URL}permission/${key}`).get();
  },

  /**
   * Check permissions by list of keys
   * @param {Array} keys
   * @returns {promise}
   */
  checkPermissions(keys: string) {
    return fetch(`${ROOT_URL}checkPermissions/${keys}`).post();
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.AuthorizationDataFetcher.js